// extracted by mini-css-extract-plugin
export default {"container":"VersionMarker_container__uzkfs","label":"VersionMarker_label__JQBqP","above":"VersionMarker_above__jY5zn","below":"VersionMarker_below__KkzPd"};